module.exports = __webpack_public_path__ + "static/hero-news-a16538c2c3d663e5ab2b6dc4b9e6f2f6.png";